import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import type { IStoreFilter } from './store-filter.interface';
import { v4 as uuid } from 'uuid';
import { BrandsEnum, SdFormCheckboxComponent, ThemesEnum } from '@seb/web-design-system/core';

@Component({
  selector: 'sd-store-filter',
  templateUrl: './store-filter.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SdFormCheckboxComponent]
})
export class SdStoreFilterComponent {
  storeFilterUUID: string = 'store-filter-' + uuid();
  themesEnum = ThemesEnum;

  @Input()
  brand: BrandsEnum;

  @Input()
  filter: IStoreFilter;

  @Output()
  filterChange = new EventEmitter<void>();

  onFilterChange(event) {
    this.filter.state = event.target.checked;
    this.filterChange.emit();
  }
}
